import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useGlobalStates } from "./utlis/ClubsContext";
import CommonLoader from "./components/common/CommonLoader";

const PUBLIC_ONLY = ["/","/login"];

// Only one protected route (you can add more later)
const PROTECTED = ["/dashboard" ,"/clubs-resort", "/clubs-details", "/staff-management", "/transactions", "/advertiser" , "/revenue-management" ,"/orders-management", "/order-details"];
const ROLE_ROUTES = {
  "/dashboard": ["admin", "editor", "viewer"],
  "/clubs-resort": ["admin", "editor","viewer"],
  "/staff-management": ["admin"],
  "/transactions": ["admin" ,"editor"],
  "/advertiser": ["admin", "editor", "viewer"],
};

export default function RouteMiddleware({ children }) {
  const { pathname } = useLocation();
  const{userRole} = useGlobalStates()
  

  const isLoggedIn = !!Cookies.get("Admin_Token");
  // const role = Cookies.get("AccessPermission");
  const role = userRole

  //  If logged in but role not allowed
  const matchedRoute = Object.keys(ROLE_ROUTES).find(route =>
    pathname.startsWith(route)
  );

    if (isLoggedIn && !role) {
   return <CommonLoader fullScreen/>
  }
  //  If not logged in → block protected routes
  if (PROTECTED.some(route => pathname.startsWith(route)) && !isLoggedIn && !role) {
    return <Navigate to="/" replace />; 
  }

  //  If logged in → block login page
  if (PUBLIC_ONLY.some(route => pathname === route) && isLoggedIn) {
    return <Navigate to="/dashboard" replace />; 
  }
  if (matchedRoute && !ROLE_ROUTES[matchedRoute].includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }


  return children;
}
